import Parts from  '@/components/Stock/Parts/Parts'
import Consumable from  '@/components/Stock/Consumable/Consumable'
import SearchReceive from  '@/components/Stock/ReceiveConsumable/SearchReceive'
import ConsumableOffice from  '@/components/Stock/Consumable-office/ConsumableOffice'
export default [
    {
        path: '/stock-parts/:pageCode',
        name: 'stock-parts',
        props: true,
        component: Parts
    },
    {
      path: '/stock-consumable-receive/:pageCode',
      name: 'stock-consumable-receive',
      props: true,
      component: SearchReceive
    },
    {
      path: '/stock-consumable/:pageCode',
      name: 'stock-consumable',
      props: true,
      component: Consumable
    },
    {
      path: '/stock-office/:pageCode',
      name: 'stock-office',
      props: true,
      component: ConsumableOffice
    }
]